import React from 'react';
import { motion } from 'framer-motion';
const before = ['Mensaje', 'Persona responde', 'Copia información', 'Actualiza CRM', 'Pregunta disponibilidad', 'Busca calendario', 'Confirma', 'Recuerda', 'Hace seguimiento'];
const withOrigen = ['Mensaje', 'IA', 'Califica', 'CRM', 'Agenda', 'Seguimiento'];
export function ResultSection() {
  return <section id="resultados" className="bg-arena py-[56px] md:py-[88px]" data-id="element-186" data-mp="1bn2djctt2hmy">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-187" data-mp="297olmrk8igyt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center max-w-[560px] mx-auto mb-10" data-id="element-188" data-mp="2494zaq1qb35x">
          <h2 className="font-display text-[28px] md:text-[38px] font-bold text-carbon leading-[1.1]" data-id="element-189" data-mp="2rzhfeo74o67l">
            Menos tareas repetitivas. Más procesos funcionando.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-190" data-mp="2god1w12lwnwy">
          {/* ANTES */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} data-id="element-191" data-mp="2kqzva6exegw9">
            <span className="block font-body text-[10px] uppercase font-medium text-carbon/35 tracking-[0.15em] mb-4" data-id="element-192" data-mp="2bwlkag1fhsiy">
              ANTES
            </span>
            <div className="flex flex-wrap gap-1.5" data-id="element-193" data-mp="220i7mg8yabhr">
              {before.map((step, idx) => <motion.span key={step} initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: 0.1 + idx * 0.05
            }} className="font-body text-[12px] text-carbon/50 bg-carbon/5 rounded-[8px] px-3 py-1.5" data-id="element-194" data-mp="1o0qvkl1zv56e" data-mpi={idx}>
                  {step}
                </motion.span>)}
            </div>
          </motion.div>

          {/* CON ORIGEN */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: 0.08
        }} data-id="element-195" data-mp="3gzfp5f3p8w01">
            <span className="block font-body text-[10px] uppercase font-medium text-verde tracking-[0.15em] mb-4" data-id="element-196" data-mp="8g88lyo6fnep">
              CON ORIGEN
            </span>
            <div className="flex flex-wrap gap-1.5" data-id="element-197" data-mp="3uwugipdijdun">
              {withOrigen.map((step, idx) => <motion.span key={step} initial={{
              opacity: 0,
              scale: 0.92
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              ease: 'easeOut',
              delay: 0.35 + idx * 0.08
            }} className="font-body text-[13px] font-medium text-arena bg-verde rounded-[8px] px-3.5 py-1.5" data-id="element-198" data-mp="3py13sz61vqvj" data-mpi={idx}>
                  {step}
                </motion.span>)}
            </div>
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.35,
        delay: 0.15
      }} className="text-center font-display text-[16px] md:text-[18px] font-semibold text-carbon mt-10 max-w-[520px] mx-auto" data-id="element-199" data-mp="13sg43l9bqwlj">
          La automatización no reemplaza tu operación. La hace funcionar
          mejor.
        </motion.p>
      </div>
    </section>;
}